import { call, put, select } from 'redux-saga/effects'
import { takeEvery, delay } from 'redux-saga'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import configPusher from 'helpers/configPusher'
import { addExportProgressAction, updateExportProgressAction,
  exportFeedbackAction, destroyExportProgressAction } from 'actions/exportActions'
import { START_EXPORT_ACTION, EXPORT_FEEDBACK } from 'actions/exportActionTypes'
import sort from 'ramda/src/sort'
import axios from 'axios'
import download from 'downloadjs'
import compressProjectForExports from 'helpers/exports/compressProjectForExports'
import { exportsSelector, currentProjectTitle } from 'selectors'

function * handleExportFeedback({ dataType, data, channel }) {
  const exportId = data.id
  const { exports } = yield select(exportsSelector)
  switch (dataType) {
    case 'generation-complete':
      if (global.sendLogs) {
        const { logs } = exports.find(e => e.id === exportId)
        console.warn(`Logs for export ${exportId}`, logs)
      }

      const { title } = yield select(currentProjectTitle)
      const { format } = exports.find(e => e.id === exportId)

      const x = new XMLHttpRequest()
      x.open("GET", data.download_url, true)
      x.responseType = "blob"
      x.onload = e => download(e.target.response, `${title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.${format}`)
      x.send()

      channel.trigger('client-download-complete', {})
      yield call(delay, 2000)
      return yield put(destroyExportProgressAction(exportId))
    case 'snapshot-taken':
      const { snapshotsTaken, snapshotCount } = exports.find(e => e.id === exportId)
      if (snapshotCount < 175) {
        yield put(updateExportProgressAction({
          id: exportId,
          snapshotsTaken: snapshotsTaken + 1,
          percentageComplete: Math.floor(((snapshotsTaken + 1) / snapshotCount) * 100)
        }))
      }
      break
    case 'log':
      const { timeStamp, lambdaNumber, message } = data
      const { logs } = exports.find(e => e.id === exportId)
      const newLog = [ ...(logs[lambdaNumber] || []), { timeStamp, message } ]
      const sortedLogs = sort((a, b) => a.timeStamp - b.timeStamp, newLog)
      return yield put(updateExportProgressAction({
        id: exportId,
        logs: { ...logs, [lambdaNumber]: sortedLogs }
      }))
  }
}

export function * watchExportFeedback(dispatch) {
  yield takeEvery(EXPORT_FEEDBACK, handleExportFeedback)
}

const newExportProgress = (id, snapshotCount, format) => ({
  id,
  snapshotCount,
  format,
  snapshotsTaken: 0,
  percentageComplete: 0,
  logs: {},
  failed: false,
  startTime: Date.now()
})

const dispathToGeneratorFn = (channel, dispatch, type, data) =>
  dispatch(exportFeedbackAction(type, data, channel))

const createExport = (format, exportData) =>
  axios
    .create({ baseURL: EXPORT_URL })
    .post('export', { format, sendLogs: global.sendLogs, ...exportData })

function * exportProgress(dispatch, { format }) {
  const state = yield select(s => s)
  const exportData = compressProjectForExports(state, format === 'csv')
  const { project: { exportId, cameras, entities: { doorControllers, doors, networkClosets, wiredDevices } } } = exportData
  const deviceCount = cameras.filter(c => !c.isMultiImager).length + doorControllers.allIds.length + doors.allIds.length + networkClosets.allIds.length + wiredDevices.allIds.length

  if (deviceCount === 0) {
    yield put(addExportProgressAction(newExportProgress(exportId, 0, format)))
    yield call(delay, 5000)
    return yield put(destroyExportProgressAction(exportId))
  }

  try {
    yield put(addExportProgressAction(newExportProgress(exportId, deviceCount + 1, format)))
    const channel = yield call(configPusher, exportId)
    channel.bind_global(dispathToGeneratorFn.bind(null, channel, dispatch))

    yield call(createExport, format, exportData)
  } catch (error) {
    yield put(updateExportProgressAction({
      id: exportId,
      failed: true
    }))
    yield put(notifyHoneybadgerAction(error, { type: 'EXPORT_PROGRESS' }))
    yield call(delay, 3000)
    yield put(destroyExportProgressAction(exportId))
   }
}

export function * watchExportProgress(dispatch) {
  yield takeEvery(START_EXPORT_ACTION, exportProgress.bind(null, dispatch))
}



// WEBPACK FOOTER //
// ./src/sagas/exportProgressSaga.js